module.exports = __webpack_public_path__ + "static/media/sound_wave.a55a685b.gif";